/* ============================================================================
FILE: po-katupirsia5-sceau-aneporon-texts-fr-en-es-20260312.js

MODE: TRILINGUE (FR/EN/ES) + protection lexicale stricte + couche audio locale
API:  window.PoK5SceauAneporonTextsFR_EN_ES_20260312
ROOT: .po-k5-section[data-po-k5="sceau_aneporon"]

RÔLE:
- injecte le contenu FR/EN/ES dans les slots data-po-slot
- conserve les termes du lexique canonique en FR, quelle que soit la langue
- verrouille la traduction automatique sur le bloc
- ajoute une couche audio locale et générale sans casser le socle
- compat Shopify / multi-instances
- alias compat : window.GoodyTwinLang
============================================================================ */

(function () {
  "use strict";

  if (window.__PO_K5_SCEAU_ANEPORON_TEXTS_20260312__) return;
  window.__PO_K5_SCEAU_ANEPORON_TEXTS_20260312__ = true;
  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-k5-section[data-po-k5="sceau_aneporon"]';

  var IMG_IDEOGRAM_CONCEPT = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Aneporon_1303_2.png?v=1772897595";
  var IMG_IDEOGRAM_FUNCTION = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Aneporon_1303_2_copie.png?v=1772897936";
  var IMG_GUIDE_NUMBER_1303 = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_1303.png?v=1773448851";

  function clampStr(v) {
    return v == null ? "" : String(v);
  }

  function normLang(raw) {
    var v = clampStr(raw).toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang() {
    try {
      var v = normLang(localStorage.getItem(STORAGE_KEY));
      if (v) return v;
    } catch (e) {}
    try {
      var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT));
      if (v2) return v2;
    } catch (e) {}
    return "";
  }

  function detectBrowserLang() {
    try {
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    } catch (e) {}
    return "fr";
  }

  function storeLang(lang) {
    var v = normLang(lang) || "fr";
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
    try { localStorage.setItem(STORAGE_KEY_COMPAT, v); } catch (e) {}
    try { document.documentElement.setAttribute("lang", v); } catch (e) {}
  }

  function getLang() {
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function notifyLocaleChanged() {
    try {
      window.dispatchEvent(new Event("po:locale-changed"));
    } catch (e) {
      try {
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      } catch (_e) {}
    }
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v) {
    if (!v) return;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === v) return;
    }
    arr.push(v);
  }

  function buildVariants(term) {
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);
    uniqPush(out, t.replace(/’/g, "'"));
    uniqPush(out, t.replace(/'/g, "’"));

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1);
    uniqPush(out, oe2);
    uniqPush(out, oe1.replace(/’/g, "'"));
    uniqPush(out, oe1.replace(/'/g, "’"));
    uniqPush(out, oe2.replace(/’/g, "'"));
    uniqPush(out, oe2.replace(/'/g, "’"));

    var lower = t.toLowerCase();
    if (lower !== t) {
      uniqPush(out, lower);
      uniqPush(out, lower.replace(/’/g, "'"));
      uniqPush(out, lower.replace(/'/g, "’"));
      uniqPush(out, lower.replace(/œ/g, "oe"));
      uniqPush(out, lower.replace(/oe/g, "œ"));
    }

    return out;
  }

  function getSimplifiedLexiqueFRList() {
    try {
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) {
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    } catch (e) {}

    try {
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)) {
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    } catch (e) {}

    try {
      if (window.PO_LEXIQUE_SIMPLIFIE && window.PO_LEXIQUE_SIMPLIFIE.meta && Array.isArray(window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr)) {
        return window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr.slice();
      }
    } catch (e) {}

    return [
      "Posœnnoïa",
      "Posœnnoïsme",
      "Organon posœnnoïal",
      "Katûvýs",
      "Katûvýsissence",
      "Katûsýs",
      "Katûvýsqun",
      "Balakallpa",
      "Isqun",
      "Threnisqun",
      "Ennéagone",
      "Ennéagone régulateur",
      "Sceau d’Équiphase",
      "Sceau de Syntonie",
      "Sceau d’Aísthisi",
      "Sceau d’Anépôron",
      "Anēporon",
      "Anépôron",
      "RéZonans",
      "Tiqqunbahu",
      "Takimarah",
      "Extratinrieur",
      "Posœnnomia",
      "Déterminisme du choix",
      "Addition synchrêtique",
      "Superposition de perspectives",
      "Sujet pluriel",
      "Méditations Posœnnoïales",
      "Accords Posœnnoïaux"
    ];
  }

  function buildProtectMatcher() {
    var base = getSimplifiedLexiqueFRList();
    var variants = [];
    for (var i = 0; i < base.length; i++) {
      var list = buildVariants(base[i]);
      for (var j = 0; j < list.length; j++) uniqPush(variants, list[j]);
    }
    variants.sort(function (a, b) { return b.length - a.length; });
    var parts = [];
    for (var k = 0; k < variants.length; k++) {
      parts.push(escapeRegExp(variants[k]));
    }
    return parts.length ? new RegExp("(" + parts.join("|") + ")", "g") : null;
  }

  var __PO_PROTECT_RE__ = null;

  function protectSpan(txt) {
    return '<span translate="no" class="po-lex-protect">' + clampStr(txt) + "</span>";
  }

  function protectLexiconInHTML(html) {
    var src = clampStr(html);
    if (!src) return "";
    if (!__PO_PROTECT_RE__) __PO_PROTECT_RE__ = buildProtectMatcher();
    if (!__PO_PROTECT_RE__) return src;

    var out = src.replace(__PO_PROTECT_RE__, function (m) {
      return protectSpan(m);
    });

    out = out.replace(/([0-9A-Za-zÀ-ÖØ-öø-ÿ])(<span translate="no" class="po-lex-protect">)/g, "$1 $2");
    out = out.replace(/(<\/span>)([0-9A-Za-zÀ-ÖØ-öø-ÿ])/g, "$1 $2");
    out = out.replace(/(<\/span>)(<[^\/\s>])/g, "$1 $2");
    out = out.replace(/([^\s>])(<span translate="no" class="po-lex-protect">)/g, function (_m, a, b) {
      if (a === " " || a === ">") return a + b;
      return a + " " + b;
    });

    return out;
  }

  function qs(root, sel) {
    try { return root.querySelector(sel); } catch (e) { return null; }
  }

  function setSlotText(root, slot, txt) {
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html) {
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(html);
  }

  function setSlotImg(root, slot, data) {
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    var src = data && data.src ? data.src : "";
    var alt = data && data.alt ? data.alt : "";
    if (src) {
      el.src = src;
      el.alt = alt;
      el.removeAttribute("hidden");
      el.style.display = "";
    } else {
      el.setAttribute("hidden", "");
      el.style.display = "none";
    }
  }

  function renderList(root, slot, items) {
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i = 0; i < arr.length; i++) {
      out.push("<li>" + protectLexiconInHTML(clampStr(arr[i])) + "</li>");
    }
    el.innerHTML = out.join("");
  }

  function renderExampleBox(root, slot, exampleTitle, exampleText) {
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    if (!exampleTitle && !exampleText) {
      el.innerHTML = "";
      return;
    }
    el.innerHTML =
      '<div class="po-lex-example__title"><strong>' + protectLexiconInHTML(exampleTitle) + '</strong></div>' +
      '<div class="po-lex-example__text">' + protectLexiconInHTML(exampleText) + "</div>";
  }

  function renderWordBlocks(root, slot, blocks) {
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i = 0; i < arr.length; i++) {
      var b = arr[i] || {};
      out.push(
        '<div class="po-axis-wb">' +
          '<div class="po-axis-wb__h">' + protectLexiconInHTML(clampStr(b.head)) + '</div>' +
          '<div class="po-axis-wb__t">' + protectLexiconInHTML(clampStr(b.text)) + '</div>' +
        '</div>'
      );
    }
    el.innerHTML = out.join("");
  }

  function applyLangbar(root, lang) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute("data-po-lang") === lang;
      buttons[i].setAttribute("aria-pressed", active ? "true" : "false");
      if (active) buttons[i].classList.add("is-active");
      else buttons[i].classList.remove("is-active");
    }
  }

  /* --------------------------------------------------------------------------
   * AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
   * -------------------------------------------------------------------------- */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    chunkPos: -1,
    activeKey: "",
    lang: "fr",
    voice: null
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang) {
    return AUDIO_UI[normLang(lang)] || AUDIO_UI.fr;
  }

  function getAudioRoots() {
    try { return document.querySelectorAll(ROOT_SEL); } catch (e) { return []; }
  }

  function getDetailBlocks(root) {
    try { return root.querySelectorAll('.po-lex-details'); } catch (e) { return []; }
  }

  function ensureAudioStyles() {
    if (document.getElementById('po-k5-audio-styles')) return;
    var style = document.createElement('style');
    style.id = 'po-k5-audio-styles';
    style.textContent =
      '.po-axis-audio-wrap{display:flex;align-items:center;gap:.6rem;margin:1rem 0 1.15rem 0;justify-content:flex-start;}' +
      '.po-axis-audio-btn{appearance:none;-webkit-appearance:none;border:1px solid rgba(184,134,11,.55);background:rgba(31,122,58,.04);color:var(--color-accent,#1f7a3a);padding:.55rem .9rem;border-radius:999px;cursor:pointer;font:inherit;font-weight:800;line-height:1.2;transition:opacity .2s ease,transform .2s ease,box-shadow .2s ease,border-color .2s ease;box-shadow:0 6px 16px rgba(31,122,58,.10);}' +
      '.po-axis-audio-btn:hover{transform:translateY(-1px);box-shadow:0 10px 26px rgba(31,122,58,.16);border-color:rgba(184,134,11,.75);}' +
      '.po-axis-audio-btn[aria-pressed="true"]{box-shadow:0 0 0 1px rgba(184,134,11,.18),0 10px 26px rgba(31,122,58,.18);background:rgba(31,122,58,.08);}' +
      '.po-lex-summary .po-axis-audio-btn{margin-left:.75rem;vertical-align:middle;flex:0 0 auto;}' +
      '@media (max-width:640px){.po-lex-summary{flex-wrap:wrap;}.po-lex-summary .po-axis-audio-btn{display:block;margin:.65rem 0 0 0;}}';
    document.head.appendChild(style);
  }

  function createAudioButton(role) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'po-axis-audio-btn';
    btn.setAttribute('data-po-audio-role', role === 'general' ? 'general' : 'detail');
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('translate', 'yes');
    return btn;
  }

  function ensureAudioButtons(root) {
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector('.po-lex-panel');
    if (panel) {
      var generalWrap = root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"]');
      if (!generalWrap) {
        generalWrap = document.createElement('div');
        generalWrap.className = 'po-axis-audio-wrap';
        generalWrap.setAttribute('data-po-audio-role', 'general');
        generalWrap.appendChild(createAudioButton('general'));

        var meta = root.querySelector('.po-axis-meta');
        var defShort = root.querySelector('[data-po-slot="def_short"]');
        var firstDetail = panel.querySelector('.po-lex-details');

        if (meta && meta.parentNode) {
          if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling);
          else meta.parentNode.appendChild(generalWrap);
        } else if (defShort && defShort.parentNode) {
          defShort.parentNode.insertBefore(generalWrap, defShort);
        } else if (firstDetail && firstDetail.parentNode) {
          firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
        } else {
          panel.appendChild(generalWrap);
        }
      }
    }

    var details = getDetailBlocks(root);
    for (var i = 0; i < details.length; i++) {
      var summary = details[i].querySelector('.po-lex-summary');
      if (!summary) continue;
      var btn = summary.querySelector('.po-axis-audio-btn[data-po-audio-role="detail"]');
      if (!btn) {
        btn = createAudioButton('detail');
        summary.appendChild(btn);
      }
      btn.setAttribute('data-po-audio-index', String(i));
    }
  }

  function getTextValue(el) {
    if (!el) return '';
    var txt = '';
    try { txt = el.innerText || el.textContent || ''; } catch (e) { txt = ''; }
    return String(txt).replace(/\s+/g, ' ').replace(/\u00a0/g, ' ').trim();
  }

  function removeAudioButtonsFromClone(root) {
    if (!root || !root.querySelectorAll) return;
    var btns = root.querySelectorAll('.po-axis-audio-btn, .po-axis-audio-wrap');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i] && btns[i].parentNode) btns[i].parentNode.removeChild(btns[i]);
    }
  }

  function collectGeneralText(root) {
    var parts = [];
    var slots = ['title', 'kicker', 'h_def', 'def_short', 'def_long'];
    for (var i = 0; i < slots.length; i++) {
      var el = root.querySelector('[data-po-slot="' + slots[i] + '"]');
      var txt = getTextValue(el);
      if (txt) parts.push(txt);
    }
    return parts.join('. ');
  }

  function collectDetailText(detail) {
    if (!detail) return '';
    var parts = [];
    var title = detail.querySelector('.po-lex-summary__title');
    var titleText = getTextValue(title);
    if (titleText) parts.push(titleText);

    var clone = detail.cloneNode(true);
    var summary = clone.querySelector('.po-lex-summary');
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    removeAudioButtonsFromClone(clone);

    var bodyText = getTextValue(clone);
    if (bodyText) parts.push(bodyText);
    return parts.join('. ');
  }

  function isWordLikeChar(ch) {
    return /[0-9A-Za-zÀ-ÖØ-öø-ÿ]/.test(ch || '');
  }

  function splitTextForSpeech(txt, maxLen) {
    var text = clampStr(txt).replace(/\s+/g, ' ').trim();
    if (!text) return [];
    var limit = Math.max(120, parseInt(maxLen, 10) || 200);
    var out = [];
    var start = 0;

    while (start < text.length) {
      var end = Math.min(start + limit, text.length);
      if (end < text.length) {
        var slice = text.slice(start, end);
        var cut = Math.max(
          slice.lastIndexOf('. '),
          slice.lastIndexOf('! '),
          slice.lastIndexOf('? '),
          slice.lastIndexOf('; '),
          slice.lastIndexOf(': '),
          slice.lastIndexOf(', ')
        );
        if (cut < Math.floor(limit * 0.55)) cut = slice.lastIndexOf(' ');
        if (cut > 0) end = start + cut + 1;
      }
      while (end < text.length && isWordLikeChar(text.charAt(end - 1)) && isWordLikeChar(text.charAt(end))) {
        end++;
      }
      var chunk = text.slice(start, end).trim();
      if (chunk) out.push(chunk);
      start = end;
    }
    return out;
  }

  function pickVoiceForLang(lang) {
    if (!PO_AUDIO_SYNTH || typeof PO_AUDIO_SYNTH.getVoices !== 'function') return null;
    var wanted = normLang(lang) || 'fr';
    var voices = [];
    try { voices = PO_AUDIO_SYNTH.getVoices() || []; } catch (e) { voices = []; }
    if (!voices.length) return null;
    for (var i = 0; i < voices.length; i++) {
      if (normLang(voices[i] && voices[i].lang) === wanted) return voices[i];
    }
    for (var j = 0; j < voices.length; j++) {
      var voiceLang = clampStr(voices[j] && voices[j].lang).toLowerCase();
      if (voiceLang.indexOf(wanted) === 0) return voices[j];
    }
    return voices[0] || null;
  }

  function buildUnits(root, role, index) {
    var units = [];
    var details = getDetailBlocks(root);
    if (role === 'general') {
      units.push({ role: 'general', index: -1 });
      for (var i = 0; i < details.length; i++) units.push({ role: 'detail', index: i });
      return units;
    }
    var start = (typeof index === 'number' && index >= 0) ? index : 0;
    for (var j = start; j < details.length; j++) units.push({ role: 'detail', index: j });
    return units;
  }

  function updateAudioPressedState() {
    var roots = getAudioRoots();
    for (var i = 0; i < roots.length; i++) {
      var btns = roots[i].querySelectorAll('.po-axis-audio-btn');
      for (var j = 0; j < btns.length; j++) btns[j].setAttribute('aria-pressed', 'false');
    }
    if (!PO_AUDIO_STATE.root || !PO_AUDIO_STATE.activeKey) return;
    var btn;
    if (PO_AUDIO_STATE.activeKey === 'general') {
      btn = PO_AUDIO_STATE.root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"] .po-axis-audio-btn[data-po-audio-role="general"]');
      if (btn) btn.setAttribute('aria-pressed', 'true');
      return;
    }
    var idx = parseInt(String(PO_AUDIO_STATE.activeKey).split(':')[1], 10);
    if (!isNaN(idx)) {
      btn = PO_AUDIO_STATE.root.querySelector('.po-axis-audio-btn[data-po-audio-role="detail"][data-po-audio-index="' + idx + '"]');
      if (btn) btn.setAttribute('aria-pressed', 'true');
    }
  }

  function refreshAudioLabels(root, lang) {
    if (!root) return;
    var ui = audioUI(lang || getLang());
    var generalBtn = root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"] .po-axis-audio-btn[data-po-audio-role="general"]');
    if (generalBtn) {
      var generalActive = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === 'general' && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending));
      generalBtn.textContent = generalActive ? ui.stop : ui.general;
    }
    var detailBtns = root.querySelectorAll('.po-axis-audio-btn[data-po-audio-role="detail"]');
    for (var i = 0; i < detailBtns.length; i++) {
      var btn = detailBtns[i];
      var idx = parseInt(btn.getAttribute('data-po-audio-index'), 10);
      var key = 'detail:' + (isNaN(idx) ? -1 : idx);
      var active = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending));
      btn.textContent = active ? ui.stop : ui.block;
    }
    updateAudioPressedState();
  }

  function refreshAllAudioLabels(lang) {
    var roots = getAudioRoots();
    for (var i = 0; i < roots.length; i++) refreshAudioLabels(roots[i], lang || getLang());
  }

  function stopAudio(silent) {
    if (PO_AUDIO_SYNTH) {
      try { PO_AUDIO_SYNTH.cancel(); } catch (e) {}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = '';
    PO_AUDIO_STATE.voice = null;
    if (!silent) refreshAllAudioLabels(getLang());
    else updateAudioPressedState();
  }

  function speakCurrentChunk() {
    if (!PO_AUDIO_SYNTH) return;
    if (!PO_AUDIO_STATE.chunks.length || PO_AUDIO_STATE.chunkPos < 0 || PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length) {
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit(true);
      return;
    }

    var txt = PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos];
    if (!txt) {
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
      return;
    }

    var utter = new SpeechSynthesisUtterance(txt);
    utter.lang = (PO_AUDIO_STATE.lang || getLang() || 'fr');
    if (PO_AUDIO_STATE.voice) utter.voice = PO_AUDIO_STATE.voice;
    utter.onend = function () {
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
    };
    utter.onerror = function () {
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
    };
    try { PO_AUDIO_SYNTH.speak(utter); } catch (e) {
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
    }
  }

  function playCurrentUnit(skipCancel) {
    if (!PO_AUDIO_SYNTH) return;
    if (!skipCancel) {
      try { PO_AUDIO_SYNTH.cancel(); } catch (e) {}
    }
    if (!PO_AUDIO_STATE.root || PO_AUDIO_STATE.unitPos < 0 || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length) {
      stopAudio();
      return;
    }

    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    if (!unit) {
      stopAudio();
      return;
    }

    var text = '';
    if (unit.role === 'general') {
      PO_AUDIO_STATE.activeKey = 'general';
      text = collectGeneralText(PO_AUDIO_STATE.root);
    } else {
      PO_AUDIO_STATE.activeKey = 'detail:' + unit.index;
      var details = getDetailBlocks(PO_AUDIO_STATE.root);
      var detail = details[unit.index];
      if (detail) {
        try { detail.open = true; } catch (e) {}
      }
      text = collectDetailText(detail);
    }

    PO_AUDIO_STATE.chunks = splitTextForSpeech(text, 210);
    PO_AUDIO_STATE.chunkPos = 0;
    refreshAllAudioLabels(PO_AUDIO_STATE.lang || getLang());

    if (!PO_AUDIO_STATE.chunks.length) {
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit(true);
      return;
    }
    speakCurrentChunk();
  }

  function startAudio(root, role, index) {
    if (!PO_AUDIO_SYNTH || !root) return;
    stopAudio(true);
    var lang = getLang();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, role, index);
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = '';
    PO_AUDIO_STATE.lang = lang;
    PO_AUDIO_STATE.voice = pickVoiceForLang(lang);
    refreshAllAudioLabels(lang);
    playCurrentUnit(false);
  }

  function bindAudioButtons(root) {
    if (!root) return;
    var btns = root.querySelectorAll('.po-axis-audio-btn');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].__poAudioBound) continue;
      btns[i].addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var role = this.getAttribute('data-po-audio-role') || 'detail';
        var index = parseInt(this.getAttribute('data-po-audio-index'), 10);
        var key = (role === 'general') ? 'general' : ('detail:' + (isNaN(index) ? -1 : index));
        var sameRoot = (PO_AUDIO_STATE.root === root);
        var sameKey = (PO_AUDIO_STATE.activeKey === key);
        if (sameRoot && sameKey && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)) {
          stopAudio();
          return;
        }
        startAudio(root, role, isNaN(index) ? -1 : index);
      });
      btns[i].__poAudioBound = true;
    }
  }

  function initAudioEverywhere(lang) {
    var roots = getAudioRoots();
    for (var i = 0; i < roots.length; i++) {
      ensureAudioButtons(roots[i]);
      bindAudioButtons(roots[i]);
      refreshAudioLabels(roots[i], lang || getLang());
    }
  }

  try {
    if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.addEventListener === 'function') {
      PO_AUDIO_SYNTH.addEventListener('voiceschanged', function () {
        if (PO_AUDIO_STATE.root) PO_AUDIO_STATE.voice = pickVoiceForLang(PO_AUDIO_STATE.lang || getLang());
      });
    }
  } catch (e) {}

  /* --------------------------------------------------------------------------
   * CONTENU
   * -------------------------------------------------------------------------- */

  var CONTENT = {
    fr: {
      title: 'Sceau d’Anépôron',
      kicker: 'Katûpirsia 5 — Sceau régulateur des dynamiques entropiques et des désagrégations silencieuses.',
      cta_translate: 'Proposer une traduction du concept',
      h_def: 'Définition canonique',
      title_img: { src: IMG_IDEOGRAM_CONCEPT, alt: 'Sceau d’Anépôron — idéogramme conceptuel' },
      chip_1: 'Idéogramme conceptuel',
      chip_1_img: { src: IMG_IDEOGRAM_CONCEPT, alt: 'Sceau d’Anépôron — idéogramme conceptuel' },
      chip_2: 'Idéogramme fonctionnel',
      chip_2_img: { src: IMG_IDEOGRAM_FUNCTION, alt: 'Sceau d’Anépôron — idéogramme fonctionnel' },
      chip_3: 'Fréquence harmonique 1303',
      chip_3_img: { src: IMG_GUIDE_NUMBER_1303, alt: 'Fréquence harmonique 1303' },
      def_short: 'Le Sceau d’Anépôron est le régulateur des dynamiques de dissolution, qu’elles soient internes ou cosmiques. Il ne combat pas l’entropie : il l’écoute, la recueille, la redistribue.',
      def_long:
        '<p><strong>Sceau d’Anépôron</strong> opère là où les formes se dissolvent — psychiquement, symboliquement ou cosmiquement — et où la <span translate="no" class="po-lex-protect">Katûvýs</span> reçoit des excès de désagrégation.</p>' +
        '<p>Le corpus le pose comme barrière poreuse anti-effondrement : non un mur, mais un filtre spiralé tenu au plus près des zones de rupture, capable d’absorber sans rigidifier. Son orientation canonique demeure nette : l’effondrement devient passage, le chaos rend possible un ordre latent, et la perte redevient matière vibratoire.</p>',
      h_features: 'Repères structurants',
      h_questions: 'Repères d’activation',
      h_family: 'Affinités posœnnoïales',
      h_wordbuild: 'Positionnements & comparaisons',
      hint_fold: 'déplier',
      example_title: 'Phrase opérative canonique',
      example: '« Anépôron (1303) : j’entre dans l’immobilité, je laisse la spirale inversée recueillir les fragments, et le passage reparaît comme ordre latent. »',
      features: [
        'Statut : Sceau régulateur de l’Ennéagone spiralé.',
        'Champ : Isqun, avec correspondance entitaire dans Threnisqun.',
        'Nature : barrière poreuse anti-effondrement, intégrée à la Katûvýs.',
        'Fonction principale : régulation des flux entropiques, des désagrégations silencieuses et des effondrements vibratoires.',
        'Fréquence harmonique : 1303.',
        'Onde d’alignement : 492.',
        'Correspondance entitaire : Anēporon.'
      ],
      questions: [
        'Si tout se défait sans axe : « Anépôron contient ».',
        'Si un chaos devient informe : « Anépôron recueille ».',
        'Si l’effondrement doit devenir passage : « Anépôron spiralise ».',
        'L’effondrement actuel relève-t-il d’une crise psychique, systémique, cosmique ou poïétique ?',
        'Faut-il entrer dans l’immobilité, laisser la spirale inversée recueillir les fragments, puis réancrer le corps vibratoire ?'
      ],
      family_1:
        '<p><strong>Position dans la Katûvýs :</strong> <span translate="no" class="po-lex-protect">Sceau d’Anépôron</span> s’inscrit à l’interface des zones de rupture et des matrices d’intégration. Il agit là où la forme s’éteint, où les repères se défont et où une recomposition doit rester possible sans nier la dissolution.</p>',
      family_2:
        '<p><strong>Correspondance entitaire :</strong> dans la logique <span translate="no" class="po-lex-protect">Isqun</span> → <span translate="no" class="po-lex-protect">Threnisqun</span>, <span translate="no" class="po-lex-protect">Sceau d’Anépôron</span> — 1303 — se condense en <span translate="no" class="po-lex-protect">Anēporon</span>, présence activable lorsque l’effondrement devient lisible et qu’une intervention située s’impose.</p>',
      word_blocks: [
        {
          head: 'Introduction canonique',
          text: 'Il est des moments où les structures s’effondrent sans bruit, où des formes se dissolvent, où des intentions se perdent dans un chaos que rien ne nomme. Le Sceau d’Anépôron s’érige à cette jonction fragile : là où plus rien ne circule, il installe une respiration.'
        },
        {
          head: 'Formation du nom',
          text: 'La formation est explicitement ancrée sur anépôron (ἀνέπορον) : « ce qui n’a pas de passage, de traversée possible ». Formule canonique à conserver : « Ce qui, bien qu’infranchissable, devient traversable par retournement intérieur. »'
        },
        {
          head: 'Fonctionnement rituelo-symbolique',
          text: 'Identifier un processus d’effondrement. Entrer dans une immobilité silencieuse. Visualiser une spirale inversée absorbant les fragments. Laisser émerger un son grave, lent, continu. Clore par une phrase vibratoire, même incomplète.'
        },
        {
          head: 'Charge 1303',
          text: 'Le corpus associe 1303 au franchissement de seuils successifs. L’écho 13 + 03 est donné comme passage par vortex suivi d’une réinitialisation triadique. Dans le tableau de Threnisqun, cette fréquence est rattachée à la désintégration des paradoxes de l’infini.'
        }
      ],
      wordbuild_notes: [
        'Psychique : immobilité spiralée.',
        'Systémique : fragmentation intégrée.',
        'Cosmique : silence + vision d’absorption.',
        'Poïétique : ré-ancrage dans le corps vibratoire.',
        'Syntonies utiles : Extratinrieur, Katûvýsissence, Tiqqunbahu, Déterminisme du choix, Posœnnomia.'
      ]
    },
    en: {
      title: 'Sceau d’Anépôron',
      kicker: 'Katûpirsia 5 — Regulatory seal of entropic dynamics and silent disintegrations.',
      cta_translate: 'Suggest a translation of the concept',
      h_def: 'Canonical definition',
      title_img: { src: IMG_IDEOGRAM_CONCEPT, alt: 'Sceau d’Anépôron — conceptual ideogram' },
      chip_1: 'Conceptual ideogram',
      chip_1_img: { src: IMG_IDEOGRAM_CONCEPT, alt: 'Sceau d’Anépôron — conceptual ideogram' },
      chip_2: 'Functional ideogram',
      chip_2_img: { src: IMG_IDEOGRAM_FUNCTION, alt: 'Sceau d’Anépôron — functional ideogram' },
      chip_3: 'Harmonic frequency 1303',
      chip_3_img: { src: IMG_GUIDE_NUMBER_1303, alt: 'Harmonic frequency 1303' },
      def_short: 'Sceau d’Anépôron regulates dynamics of dissolution, whether internal or cosmic. It does not fight entropy: it listens to it, gathers it, redistributes it.',
      def_long:
        '<p><strong>Sceau d’Anépôron</strong> operates wherever forms dissolve — psychically, symbolically, or cosmically — and where <span translate="no" class="po-lex-protect">Katûvýs</span> receives excesses of disintegration.</p>' +
        '<p>The corpus places it as a porous anti-collapse barrier: not a wall, but a spiral filter held close to zones of rupture, capable of absorbing without rigidifying. Its canonical orientation remains clear: collapse becomes passage, chaos makes a latent order possible, and loss becomes vibratory matter again.</p>',
      h_features: 'Structural markers',
      h_questions: 'Activation markers',
      h_family: 'Posœnnoïal affinities',
      h_wordbuild: 'Positions & comparisons',
      hint_fold: 'unfold',
      example_title: 'Canonical operative phrase',
      example: '“Anépôron (1303): I enter stillness, I let the inverted spiral gather the fragments, and passage reappears as latent order.”',
      features: [
        'Status: regulatory seal of the spiral Ennéagone.',
        'Field: Isqun, with entitary correspondence in Threnisqun.',
        'Nature: porous anti-collapse barrier, integrated into Katûvýs.',
        'Main function: regulation of entropic flows, silent disintegrations, and vibratory collapses.',
        'Harmonic frequency: 1303.',
        'Alignment wave: 492.',
        'Entitary correspondence: Anēporon.'
      ],
      questions: [
        'If everything falls apart without an axis: “Anépôron contains.”',
        'If chaos becomes formless: “Anépôron gathers.”',
        'If collapse must become passage: “Anépôron spiralises.”',
        'Does the present collapse belong to a psychic, systemic, cosmic, or poietic crisis?',
        'Should one enter stillness, let the inverted spiral gather the fragments, then re-anchor the vibratory body?'
      ],
      family_1:
        '<p><strong>Position in Katûvýs:</strong> <span translate="no" class="po-lex-protect">Sceau d’Anépôron</span> stands at the interface of zones of rupture and matrices of integration. It acts where form fades, where bearings dissolve, and where recomposition must remain possible without denying dissolution.</p>',
      family_2:
        '<p><strong>Entitary correspondence:</strong> within the <span translate="no" class="po-lex-protect">Isqun</span> → <span translate="no" class="po-lex-protect">Threnisqun</span> logic, <span translate="no" class="po-lex-protect">Sceau d’Anépôron</span> — 1303 — condenses into <span translate="no" class="po-lex-protect">Anēporon</span>, an activable presence when collapse becomes legible and situated intervention is required.</p>',
      word_blocks: [
        {
          head: 'Canonical introduction',
          text: 'There are moments when structures collapse without noise, when forms dissolve, when intentions are lost in a chaos that nothing names. Sceau d’Anépôron rises at this fragile junction: where nothing circulates anymore, it installs a respiration.'
        },
        {
          head: 'Formation of the name',
          text: 'The formation is explicitly anchored in anépôron (ἀνέπορον): “that which has no passage, no traversable path.” Canonical formula to preserve: “That which, though impassable, becomes traversable through inner reversal.”'
        },
        {
          head: 'Ritual-symbolic functioning',
          text: 'Identify a process of collapse. Enter silent stillness. Visualise an inverted spiral absorbing the fragments. Let a deep, slow, continuous sound emerge. Close with a vibratory phrase, even if incomplete.'
        },
        {
          head: 'Charge 1303',
          text: 'The corpus associates 1303 with the crossing of successive thresholds. The echo 13 + 03 is given as a vortex passage followed by triadic reset. In the Threnisqun table, this frequency is tied to the disintegration of the paradoxes of infinity.'
        }
      ],
      wordbuild_notes: [
        'Psychic: spiral stillness.',
        'Systemic: integrated fragmentation.',
        'Cosmic: silence + absorption vision.',
        'Poietic: re-anchoring in the vibratory body.',
        'Useful syntonies: Extratinrieur, Katûvýsissence, Tiqqunbahu, Déterminisme du choix, Posœnnomia.'
      ]
    },
    es: {
      title: 'Sceau d’Anépôron',
      kicker: 'Katûpirsia 5 — Sello regulador de las dinámicas entrópicas y de las desagregaciones silenciosas.',
      cta_translate: 'Proponer una traducción del concepto',
      h_def: 'Definición canónica',
      title_img: { src: IMG_IDEOGRAM_CONCEPT, alt: 'Sceau d’Anépôron — ideograma conceptual' },
      chip_1: 'Ideograma conceptual',
      chip_1_img: { src: IMG_IDEOGRAM_CONCEPT, alt: 'Sceau d’Anépôron — ideograma conceptual' },
      chip_2: 'Ideograma funcional',
      chip_2_img: { src: IMG_IDEOGRAM_FUNCTION, alt: 'Sceau d’Anépôron — ideograma funcional' },
      chip_3: 'Frecuencia armónica 1303',
      chip_3_img: { src: IMG_GUIDE_NUMBER_1303, alt: 'Frecuencia armónica 1303' },
      def_short: 'Sceau d’Anépôron regula las dinámicas de disolución, internas o cósmicas. No combate la entropía: la escucha, la recoge y la redistribuye.',
      def_long:
        '<p><strong>Sceau d’Anépôron</strong> opera allí donde las formas se disuelven — psíquica, simbólica o cósmicamente — y donde la <span translate="no" class="po-lex-protect">Katûvýs</span> recibe excesos de desagregación.</p>' +
        '<p>El corpus lo sitúa como barrera porosa anti-colapso: no un muro, sino un filtro espiral sostenido al borde de las zonas de ruptura, capaz de absorber sin rigidificar. Su orientación canónica permanece clara: el derrumbe se vuelve paso, el caos vuelve posible un orden latente y la pérdida se convierte nuevamente en materia vibratoria.</p>',
      h_features: 'Referentes estructurantes',
      h_questions: 'Referentes de activación',
      h_family: 'Afinidades posœnnoïales',
      h_wordbuild: 'Posicionamientos y comparaciones',
      hint_fold: 'desplegar',
      example_title: 'Frase operativa canónica',
      example: '« Anépôron (1303): entro en la inmovilidad, dejo que la espiral invertida recoja los fragmentos, y el paso reaparece como orden latente. »',
      features: [
        'Estatuto: sello regulador del Ennéagone espiral.',
        'Campo: Isqun, con correspondencia entitaria en Threnisqun.',
        'Naturaleza: barrera porosa anti-colapso, integrada en la Katûvýs.',
        'Función principal: regulación de los flujos entrópicos, las desagregaciones silenciosas y los colapsos vibratorios.',
        'Frecuencia armónica: 1303.',
        'Onda de alineación: 492.',
        'Correspondencia entitaria: Anēporon.'
      ],
      questions: [
        'Si todo se deshace sin eje: « Anépôron contiene ».',
        'Si un caos se vuelve informe: « Anépôron recoge ».',
        'Si el derrumbe debe convertirse en paso: « Anépôron spiralise ».',
        '¿El colapso actual pertenece a una crisis psíquica, sistémica, cósmica o poiética?',
        '¿Hace falta entrar en la inmovilidad, dejar que la espiral invertida recoja los fragmentos y luego reanclar el cuerpo vibratorio?'
      ],
      family_1:
        '<p><strong>Posición en la Katûvýs:</strong> <span translate="no" class="po-lex-protect">Sceau d’Anépôron</span> se sitúa en la interfaz entre las zonas de ruptura y las matrices de integración. Actúa allí donde la forma se apaga, donde las referencias se deshacen y donde la recomposición debe permanecer posible sin negar la disolución.</p>',
      family_2:
        '<p><strong>Correspondencia entitaria:</strong> en la lógica <span translate="no" class="po-lex-protect">Isqun</span> → <span translate="no" class="po-lex-protect">Threnisqun</span>, <span translate="no" class="po-lex-protect">Sceau d’Anépôron</span> — 1303 — se condensa en <span translate="no" class="po-lex-protect">Anēporon</span>, presencia activable cuando el colapso se vuelve legible y se impone una intervención situada.</p>',
      word_blocks: [
        {
          head: 'Introducción canónica',
          text: 'Hay momentos en que las estructuras se derrumban sin ruido, en que las formas se disuelven y en que las intenciones se pierden en un caos que nada nombra. Sceau d’Anépôron se yergue en esa juntura frágil: allí donde ya nada circula, instala una respiración.'
        },
        {
          head: 'Formación del nombre',
          text: 'La formación está anclada explícitamente en anépôron (ἀνέπορον): « aquello que no tiene paso, ni travesía posible ». Fórmula canónica que debe conservarse: « Aquello que, aunque infranqueable, se vuelve atravesable por un retournement intérieur. »'
        },
        {
          head: 'Funcionamiento ritual-simbólico',
          text: 'Identificar un proceso de derrumbe. Entrar en una inmovilidad silenciosa. Visualizar una espiral invertida absorbiendo los fragmentos. Dejar emerger un sonido grave, lento y continuo. Cerrar con una frase vibratoria, incluso incompleta.'
        },
        {
          head: 'Carga 1303',
          text: 'El corpus asocia 1303 al cruce de umbrales sucesivos. El eco 13 + 03 se da como paso por vórtice seguido de una reinicialización triádica. En la tabla de Threnisqun, esta frecuencia queda ligada a la desintegración de las paradojas del infinito.'
        }
      ],
      wordbuild_notes: [
        'Psíquico: inmovilidad espiral.',
        'Sistémico: fragmentación integrada.',
        'Cósmico: silencio + visión de absorción.',
        'Poiético: reanclaje en el cuerpo vibratorio.',
        'Sintonías útiles: Extratinrieur, Katûvýsissence, Tiqqunbahu, Déterminisme du choix, Posœnnomia.'
      ]
    }
  };

  function applyContent(root, lang) {
    var c = CONTENT[lang] || CONTENT.fr;
    setSlotImg(root, 'title_img', c.title_img);
    setSlotText(root, 'title', c.title);
    setSlotText(root, 'kicker', c.kicker);
    setSlotText(root, 'h_def', c.h_def);
    setSlotText(root, 'chip_1', c.chip_1);
    setSlotImg(root, 'chip_1_img', c.chip_1_img);
    setSlotText(root, 'chip_2', c.chip_2);
    setSlotImg(root, 'chip_2_img', c.chip_2_img);
    setSlotText(root, 'chip_3', c.chip_3);
    setSlotImg(root, 'chip_3_img', c.chip_3_img);
    setSlotHTML(root, 'def_short', c.def_short);
    setSlotHTML(root, 'def_long', c.def_long);
    setSlotText(root, 'h_features', c.h_features);
    setSlotText(root, 'hint_fold', c.hint_fold);
    renderList(root, 'features', c.features);
    setSlotText(root, 'h_questions', c.h_questions);
    setSlotText(root, 'hint_fold2', c.hint_fold);
    renderList(root, 'questions', c.questions);
    renderExampleBox(root, 'example_box', c.example_title, c.example);
    setSlotText(root, 'h_family', c.h_family);
    setSlotText(root, 'hint_fold3', c.hint_fold);
    setSlotHTML(root, 'family_1', c.family_1);
    setSlotHTML(root, 'family_2', c.family_2);
    setSlotText(root, 'h_wordbuild', c.h_wordbuild);
    renderWordBlocks(root, 'wordbuild_blocks', c.word_blocks);
    renderList(root, 'wordbuild_notes', c.wordbuild_notes);
    setSlotText(root, 'cta_translate', c.cta_translate);
    applyLangbar(root, lang);
  }

  function lockTranslation(root) {
    if (!root) return;
    root.setAttribute('translate', 'no');
    root.classList.add('notranslate');
    var scope = root.querySelector('[data-po-lex-scope]');
    if (scope) {
      scope.setAttribute('translate', 'no');
      scope.classList.add('notranslate');
    }
  }

  function bindLangButtons(root) {
    var buttons = root.querySelectorAll('[data-po-lang]');
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].__poLangBound) continue;
      buttons[i].addEventListener('click', function () {
        setLang(this.getAttribute('data-po-lang'));
      });
      buttons[i].__poLangBound = true;
    }
  }

  function applyAll(lang) {
    var safeLang = normLang(lang) || getLang();
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      lockTranslation(roots[i]);
      applyContent(roots[i], safeLang);
      bindLangButtons(roots[i]);
    }
    initAudioEverywhere(safeLang);
  }

  function setLang(lang) {
    var safeLang = normLang(lang) || 'fr';
    storeLang(safeLang);
    __PO_PROTECT_RE__ = null;
    applyAll(safeLang);
    notifyLocaleChanged();
    return safeLang;
  }

  function init() {
    storeLang(getLang());
    applyAll(getLang());
  }

  window.PoK5SceauAneporonTextsFR_EN_ES_20260312 = {
    init: init,
    getLang: getLang,
    setLang: setLang,
    normLang: normLang,
    stopAudio: stopAudio
  };

  window.PoK5AneporonTextsFR_EN_ES_20260312 = window.PoK5SceauAneporonTextsFR_EN_ES_20260312;

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = setLang;
  window.GoodyTwinLang.init = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
